function fixswatchsizes(wrapper,color)
  {
  //console.log('set sold outs with '+color );
  var firstaddtoall = wrapper.querySelectorAll('.sizes_available span');
  if(firstaddtoall.length == 0)return;

  firstaddtoall.forEach(async (item) => {
    item.classList.add('soldout');
  });


  var jsonld = JSON.parse(wrapper.querySelector('script[type="application/ld+json"]').innerText);
  var allvariants = jsonld.variants;
  allvariants.forEach(async (variant) => {
    //console.log(variant)
    if(variant.public_title.includes(color) && variant.available)
    {
      var item = wrapper.querySelector(`span[data-value='${variant.option2}']`);
      if(item)item.classList.remove('soldout');
    }
  });
}


/*
function setSwatchImage(prodID,title,linkValue1)
  {
    var productWrapper = document.querySelector('.card[data-id="'+prodID+'"]');
    var selectedSlide = productWrapper.querySelector('.swiper-slide[data-title="'+title+'"]');
    if(productWrapper && selectedSlide)
    {
     var slideIndex = parseInt(selectedSlide.dataset.swiperSlideIndex);
     var swiperModule = productWrapper.querySelector('.swiper');
      if(swiperModule)
      {
        swiperModule.swiper.slideToLoop(slideIndex,0)
      }
    }

      // updating url also
      var newURL = selectedSlide.dataset.variantlink;
      if(linkValue1 != "")
      {
        newURL = linkValue1;
      }
      var allLinks = productWrapper.querySelectorAll('a');
      for(var i=0; i<allLinks.length; i++)
      {
        allLinks[i].href=newURL;
      }

     fixswatchsizes(productWrapper,title);
  }
*/
function setSwatchImageNew(prodID, title,linkValue1,imageItem,imageItem2) {
  var productWrapper = document.querySelector('.card[data-id="' + prodID + '"]');
  var selectedSlide = productWrapper.querySelector('.swiper-slide[data-title="' + title + '"]');
  if (productWrapper && selectedSlide) {
    /*
    productWrapper.querySelectorAll('.swiper-slide[data-title]').forEach((element) => {
      if (!element.classList.contains('hidden')) {
        element.classList.add('hidden');
      }
    });
    selectedSlide.classList.remove('hidden');
    */

     var slideIndex = parseInt(selectedSlide.dataset.swiperSlideIndex);
     var swiperModule = productWrapper.querySelector('.swiper');
      if(swiperModule)
      {
        swiperModule.swiper.slideToLoop(slideIndex,0)
      }

    //    if(productWrapper.querySelector('.swiper.cardSlider.swiper-initialized'))
    //    productWrapper.querySelector('.swiper.cardSlider.swiper-initialized').swiper.slideToLoop(selectedSlide.dataset.swiperSlideIndex);

    // productWrapper.querySelectorAll('.swiper-slide[data-title="' + title + '"]').forEach((element, index) => {
    //   if (index === 0) {
    //     element.classList.remove('hidden');
    //   }
    // });
    }
    var swiperModule = productWrapper.querySelector('.swiper');
    if(!swiperModule)
    {
      // update image if not swiper
      var imageItemv = productWrapper.querySelector('.media img');
      if(imageItemv && imageItem != "")
      {
        imageItemv.src = imageItem;
        imageItemv.setAttribute('srcset',imageItem);

        // for rollover, need to hide this
       /* var rolloverImage = productWrapper.querySelector('.rollover_image');
        if(rolloverImage){
          productWrapper.classList.add('removeHoverOverlay');
        }
        */
      }

      // lets check if rollover, then update 2nd image also
      var imageItemv2 = productWrapper.querySelector('.rollover_image img');
      if(imageItemv2 && imageItem2 != "")
      {
        imageItemv2.src = imageItem2;
        imageItemv2.setAttribute('srcset',imageItem2);
      }
    }

    // updating url also
    var newURL = "";
    if(selectedSlide){
      newURL = selectedSlide.dataset.variantlink;
    }
    if(linkValue1 != "")
    {
      newURL = linkValue1;
    }
    var allLinks = productWrapper.querySelectorAll('a');
    for(var i=0; i<allLinks.length; i++)
    {
      if(newURL != "")
      allLinks[i].href=newURL;
    }

  fixswatchsizes(productWrapper,title);
}

function setLinksOnly(prodID,title,linkValue1)
  {
    var productWrapper = document.querySelector('.card[data-id="'+prodID+'"]');
    var selectedSlide = productWrapper.querySelector('.swiper-slide[data-title="'+title+'"]');
     // updating url also
    var newURL = "";
    if(selectedSlide){
      newURL = selectedSlide.dataset.variantlink;
    }
    if(linkValue1 != "")
    {
      newURL = linkValue1;
    }
    var allLinks = productWrapper.querySelectorAll('a');
    for(var i=0; i<allLinks.length; i++)
    {
      if(newURL != "")
      allLinks[i].href=newURL;
    }

    fixswatchsizes(productWrapper,title);
  }





function mouseenterFnct(vname, prodID) {
  let fnlist = document.querySelectorAll('.card[data-id="' + prodID + '"] .image_display_rollover .swiper-slide[data-title="' + vname + '"]');
  //console.log(fnlist);
  if (fnlist.length > 1) {
    fnlist[0].style.display = 'none';
    fnlist[1].style.setProperty('display', 'inherit', 'important');
  }
}

function mouseleaveFnct(vname, prodID) {
  let fnlist = document.querySelectorAll('.card[data-id="' + prodID + '"] .image_display_rollover .swiper-slide[data-title="' + vname + '"]');
  //console.log(fnlist);
  if (fnlist.length > 1) {
    fnlist[0].style.removeProperty('display');
    fnlist[1].style.removeProperty('display');
  }
}

document.querySelectorAll('.card .image_display_rollover .swiper-slide').forEach((element) => {
  element.addEventListener('mouseenter', () => {
    let dataset_title = element.dataset.title;
    mouseenterFnct(dataset_title, element.dataset.cardid);
  });
  element.addEventListener('mouseleave', () => {
    let dataset_title = element.dataset.title;
    mouseleaveFnct(dataset_title, element.dataset.cardid);
  });
});